export default __webpack_public_path__ + "static/media/back_guide.c54071a3.jpg";